import type { LevelId } from './types';

export interface LevelIdentity {
  number: number;
  accent: string;
  accentRgb: string;
  glow: string;
  foilHue: number;
  artwork: string;
}

export const LEVEL_IDENTITY: Record<LevelId, LevelIdentity> = {
  beginner: {
    number: 1,
    accent: '#b6bec9', accentRgb: '182, 190, 201', glow: '#59616d', foilHue: 215,
    artwork: '/assets/cards/level-1-beginner.png',
  },
  user: {
    number: 2,
    accent: '#43c6d8', accentRgb: '67, 198, 216', glow: '#176d7a', foilHue: 188,
    artwork: '/assets/cards/level-2-user.png',
  },
  navigator: {
    number: 3,
    accent: '#b596ff', accentRgb: '181, 150, 255', glow: '#6344ad', foilHue: 264,
    artwork: '/assets/cards/level-3-navigator.png',
  },
  strategist: {
    number: 4,
    accent: '#f28b4b', accentRgb: '242, 139, 75', glow: '#9b431d', foilHue: 28,
    artwork: '/assets/cards/level-4-strategist.png',
  },
  creator: {
    number: 5,
    accent: '#f0c85a', accentRgb: '240, 200, 90', glow: '#987421', foilHue: 46,
    artwork: '/assets/cards/level-5-creator.png',
  },
};
